
import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

import LoginPage from "./pages/LoginPage";
import DashboardLayout from "./components/DashboardLayout";
import Profile from "./pages/Profile";
import PunchIn from "./pages/PunchIn";
import PunchOut from "./pages/PunchOut";
import Attendance from "./pages/Attendance";
import AttendanceRegularizationList from "./pages/AttendanceRegularization";
import AttendanceReport from "./pages/AttendanceReport";
import LedgerReport from "./pages/LedgerReport";
import Accounts from "./pages/Accounts";
import Leave from "./pages/Leave";
import Query from "./pages/Query";
import { Toaster } from "react-hot-toast";


import { AttendanceProvider } from "./context/AttendanceContext"; // agar ye needed hai to rakho
import { AuthProvider } from "./context/AuthContext";
import Dashboard from "./pages/Dashboard";
import LeaveCard from "./pages/LeaveCard";
import Jobs from "./pages/Jobs";
import Approve_Regularization from "./pages/Approve_Regularization";
import Approve_LeavePage from "./pages/Approve_LeavePage";
import Biometric from "./pages/Biometric";


// ✅ Protected Route
function ProtectedRoute({ children }) {
  const { isLoggedIn } = useSelector((state) => state.auth);

  return isLoggedIn ? children : <Navigate to="/login" replace />;
}

// ✅ Public Route
function PublicRoute({ children }) {
  const { isLoggedIn } = useSelector((state) => state.auth);

  return isLoggedIn
    ? <Navigate to="/dashboard/dashboard" replace />
    : children;
}

export default function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-right" reverseOrder={false} />
      <AuthProvider>
        <AttendanceProvider>
          <Routes>
            <Route
              path="/login"
              element={
                <PublicRoute>
                  <LoginPage />
                </PublicRoute>
              }
            />

            <Route
              path="/biometric"
              element={
                <PublicRoute>
                  <Biometric />
                </PublicRoute>
              }
            />

            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <DashboardLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Navigate to="profile" replace />} />
              <Route path="profile" element={<Profile />} />
              <Route path="punch-in" element={<PunchIn />} />
              <Route path="punch-out" element={<PunchOut />} />
              <Route path="jobs" element={<Jobs />} />
              <Route path="attendance" element={<Attendance />} />
              <Route path="leave" element={<Leave />} />
              <Route path="leave-card" element={<LeaveCard />} />
              <Route path="query" element={<Query />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="Regularization" element={<AttendanceRegularizationList />} />
              <Route path="Accounts" element={<Accounts />} />

              {/* <Route path="supervisor/approve-regularization" element={<Approve_Regularization />} />
              <Route path="supervisor/approve-leave" element={<Approve_LeavePage />} /> */}


              <Route
                path="supervisor/approve-regularization"
                element={
                  <ProtectedRoute requiredPermission={86}>
                    <Approve_Regularization />
                  </ProtectedRoute>
                }
              />

              <Route
                path="supervisor/approve-leave"
                element={
                  <ProtectedRoute requiredPermission={87}>
                    <Approve_LeavePage />
                  </ProtectedRoute>
                }
              />



              {/* Report submenu: Attendance + Ledger — both use the same
                Report component, which switches its view based on the URL */}
              <Route path="report/attendance" element={<AttendanceReport />} />
              <Route path="report/ledger" element={<LedgerReport />} />
              {/* Bare /dashboard/report -> redirect to Attendance tab */}
              <Route path="report" element={<Navigate to="attendance" replace />} />

            </Route>

            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        </AttendanceProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

